<template>
  <div class="order_box" v-loading="pageLoading">
    <div class="page_title order_title">
      <custom-breadcrumb/>
      <!-- 只有是 入驻模式 && vidirect 供应商才显示该按钮 -->
      <!-- <button v-if="(supplierManagementModelFlag && isVidirect)" class="creat_button" @click="toCreateOrder()">
        Create Order
      </button> -->
    </div>
    <div class="page_content flex">
      <div class="order_nav flex">
        <div class="nav_msg flex">
          <el-dropdown
            trigger="click"
            placement="bottom-start"
            @command="changeOrderTime"
          >
            <span class="el-dropdown-link">
              <span v-if="orderChangeTime == 'All'">{{ orderChangeTime }}</span>
              <span v-if="orderChangeTime != 'All'"
              >{{ orderChangeTime }} days</span
              >
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="7">Last 7 days</el-dropdown-item>
              <el-dropdown-item command="30">Last 30 days</el-dropdown-item>
              <el-dropdown-item command="All">All</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="nav_msg flex">
          <p class="nac_msg_name">Orders</p>
          <p class="nac_msg_num">{{ ordersCount.ordersCount }}</p>
        </div>
        <div class="nav_msg flex">
          <p class="nac_msg_name">Paid Order</p>
          <p class="nac_msg_num">{{ ordersCount.paidOrdersCount }}</p>
        </div>
        <div class="nav_msg flex">
          <p class="nac_msg_name">Shipped Order</p>
          <p class="nac_msg_num">{{ ordersCount.fulfilledOrderCount }}</p>
        </div>
      </div>
    </div>
    <div class="search-box">
      <el-select
        v-model="selectData.selectOrderStatus"
        clearable
        placeholder="Order status"
        @change="changSelectHandel()"
      >
        <el-option
          v-for="item in orderStatua"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select
        style="margin-left:15px"
        v-model="selectData.selectOrderType"
        clearable
        placeholder="Order Type"
        @change="changSelectHandel()"
      >
        <el-option
          v-for="item in orderType"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <div class="date_text" style="width: 180px;">Start Create Time</div>
      <el-date-picker
        @change="changSelectHandel()"
        v-model="selectData.dateValue"
        style="width: 45%; width: 200px"
        value-format="yyyy-MM-dd"
        type="date"
        placeholder="yyyy-mm-dd"
      >
      </el-date-picker>
      <el-input
        class="search_input"
        v-model="selectData.keyWords"
        prefix-icon="el-icon-search"
        placeholder="Search orders by SKU,Product Name,Retailer Email,or order #"
        clearable
      />
      <el-button type="primary" class="search-btn" @click="changSelectHandel()"
      >Search
      </el-button
      >
    </div>
    <div class="page_table">
      <el-table :data="ordersData" height="calc(100vh - 400px)" stripe
                style="width: 100%; height: calc(100vh - 400px);">
        <el-table-column
          prop="createdAt"
          label="Create Time/Order ID"
          width="250"
          fixed
        >
          <template slot-scope="scope">
            <span style="color:#707070">
              {{ scope.row.createdAt }}
              <span v-if="scope.row['type']=='7'" style="background: #F3E93D;padding: 0 5px;">ViLocal</span>
            </span>
            <span>{{ scope.row.orderId }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="retailerName" label="Retailer" width="270" fixed>
          <template slot-scope="scope">
            <img
              v-if="scope.row.userSource == 1"
              class="little_logo"
              src="https://shopvidi.oss-cn-beijing.aliyuncs.com/vidirect/v-logo.png"
              alt=""
            />
            <span>{{ scope.row.retailerName }}</span>
            <br>
            <span>{{ scope.row.remark }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="orderStatus" label="Status" width="100">
          <template slot-scope="scope">
            <span>{{  scope.row.orderStatus | statusDis }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="Action" width="320">
          <template slot-scope="scope">
            <!-- SV-1.4.15.1 由于编辑和详情入口统一，取消该入口 -->
            <!-- <el-button
              v-if="scope.row.orderStatus == 0 || scope.row.orderStatus == 11"
              type="primary"
              class="action_button"
              @click="openEditOrder(scope.row.orderId)"
              >Edit</el-button
            >
           <el-button
              v-if="scope.row.orderStatus == 0 && (supplierManagementModelFlag || operate)"
              type="primary"
              class="action_button"
              @click="changeOrderButton(scope.row.orderId, 2, 'Cancel')"
            >Cancel
            </el-button
            > -->
            <!-- SV-1.4.15.1 取消Accept 操作 -->
            <!-- <el-button
              v-if="scope.row.orderStatus == 1 && supplierManagementModelFlag"
              type="primary"
              class="action_button"
              @click="changeOrderButton(scope.row.orderId, 40, 'Accept')"
              >Accept</el-button
            > -->
            <!-- brand 自发货 确认装运后，才显示shipped -->
            <!-- 2.2.12修改前的判断条件 v-if="scope.row.orderStatus == 40 && (scope.row['isProceedShipmented']!=null && scope.row['isProceedShipmented'])  && (operate || (supplierManagementModelFlag && scope.row.brandShippingModel!==null && scope.row.brandShippingModel === 2)) " -->
            <el-button
              v-if="scope.row.isShowShipped"
              type="primary"
              class="action_button"
              @click="gotoShipped(scope.row)">
              Shipped
            </el-button>
            <el-button
              v-if="(scope.row.orderStatus == 0 || scope.row.orderStatus == 11) && (operate || (supplierManagementModelFlag && scope.row.brandShippingModel!==null && scope.row.brandShippingModel === 2))"
              type="primary"
              class="action_button orange_background"
              @click="toCopyInfo(scope.row.retailerName,scope.row.orderId,scope.row.brandShippingModel)">
              Send Order Link
            </el-button>
            <!-- 入驻和自营、并且为备货中显示以下仅退款按钮 begin-->
            <template v-if="(operate || supplierManagementModelFlag) && (scope.row.orderStatus == 40 || scope.row.orderStatus ==  4)">
              <el-button
                type="primary"
                v-if="scope.row.orderStatus == 40 && scope.row['type'] !=='6' && scope.row['type'] !=='1' && !scope.row['isRefuseFulfill'] && !scope.row['isProceedShipmented']
                && (!scope.row['isMarkNonwares'] || (scope.row['isMarkNonwares'] && scope.row['isNonwaresRetailerAgree']))
                && !scope.row['isExistServiceOrder']"
                class="action_button action_button2"
                @click="$refs.outStackDialog.show(true,scope.row.orderId)">
                Proceed the shipment
              </el-button>
              <el-button
                type="primary"
                v-if="scope.row['isShowEditItem']"
                class="action_button action_button2"
                @click="$router.push({ path: 'edit-item-avaliability',query: {'orderId': scope.row['orderId'], 'userSource': scope.row['userSource']} })">
                Edit Item Availability
              </el-button>

              <el-button
                type="primary"
                v-if="scope.row.orderStatus == 40 && scope.row['type'] !=='6' && scope.row['type'] !=='1' && !scope.row['isRefuseFulfill'] && !scope.row['isProceedShipmented'] && !scope.row['isMarkNonwares'] && !scope.row['isExistServiceOrder']"
                class="action_button action_button2"
                @click="$refs.outStackDialog.show(false,scope.row.orderId)">
              Reject order
              </el-button>

              <!-- 缺货待retailer确认 -->
              <span v-if="scope.row.orderStatus == 40 && scope.row['isMarkNonwares'] && (scope.row['isNonwaresRetailerAgree']==null)">
                  There are out of stock items in the order, waiting for confirmation from the retailer
              </span>
              <!-- 缺货待retailer拒绝 -->
              <span v-if="scope.row.orderStatus == 40 && scope.row['isMarkNonwares'] && (scope.row['isNonwaresRetailerAgree']!=null && !scope.row['isNonwaresRetailerAgree'])">
                The retailer refuses to ship the remaining goods and has generated an after sale order
              </span>
              <!-- 整单拒绝 -->
              <span v-if="scope.row.orderStatus == 40 && scope.row['isRefuseFulfill']">The order was rejected by the brand</span>

            </template>
            <!-- 仅退款按钮end -->

          </template>
        </el-table-column>
        <el-table-column label="Order Review" width="150" v-if="userInfo.id === superUserId">
          <template slot-scope="scope" v-if="scope.row.orderStatus === 1 && !scope.row.isExistServiceOrder">
            <span v-if="scope.row.type!=='7' || (scope.row.type==='7' && (scope.row.auditStatus ===2 || (scope.row.auditStatus ===0 && scope.row.brandReviewStatus ===0)))" @click="passOrder(scope.row.orderId)"
                 style="text-decoration: underline;cursor: pointer;">
                备货中
            </span>
            <span @click="rejectOrder(scope.row.orderId)"
                 style="text-decoration: underline;cursor: pointer;margin-left:10px">
                拒绝履约
            </span>
           </template>
        </el-table-column>
        <el-table-column prop="payAmount" label="Order Details" width="120">
          <template slot-scope="scope">
            <div @click="toOrderDetail(scope.row)"
                 style="text-decoration: underline;cursor: pointer;">
                {{ (scope.row.orderStatus=='0'|| scope.row.orderStatus=='11' )?'Edit':'View' }}
            </div>
           </template>
        </el-table-column>
        <!-- 供应商审核 -->
        <el-table-column label="Store Info" width="150" v-if="userInfo.id === superUserId || userInfo.supplierManagementModel ===1 || userInfo.supplierManagementModel ===2">
          <!-- TODO 这里要等后端确定的运营审核状态字段后，加上运营审核状态为通过后方可显示 -->
          <template slot-scope="scope" v-if="scope.row.type ==='7' && scope.row.auditStatus!==0 && scope.row.brandReviewStatus===2">
            <span v-if="scope.row.auditStatus===1" @click="gotoStoreInfo(scope.row.orderId,true)"
                 style="text-decoration: underline;cursor: pointer;">
                Store review
            </span>
            <span v-if="scope.row.auditStatus===2" @click="gotoStoreInfo(scope.row.orderId,true)"
                 style="text-decoration: underline;cursor: pointer;">
                Store approved
            </span>
            <span v-if="scope.row.auditStatus===3" @click="gotoStoreInfo(scope.row.orderId,true)"
                 style="text-decoration: underline;cursor: pointer;">
                Store rejected
            </span>
           </template>
        </el-table-column>
        <!-- 运营审核 -->
        <!-- TODO 这里要等后端确定的运营审核状态字段后，将供应商审核状态信息改为运用审核状态字段 -->
        <el-table-column label="运营审核" width="150" v-if="userInfo.id === superUserId">
          <template slot-scope="scope" v-if="scope.row.type ==='7' && scope.row.brandReviewStatus!==0">
            <span v-if="scope.row.brandReviewStatus===1" @click="gotoStoreInfo(scope.row.orderId,false)"
                 style="text-decoration: underline;cursor: pointer;">
                Store review
            </span>
            <span v-if="scope.row.brandReviewStatus===2" @click="gotoStoreInfo(scope.row.orderId,false)"
                 style="text-decoration: underline;cursor: pointer;">
                Store approved
            </span>
            <span v-if="scope.row.brandReviewStatus===3" @click="gotoStoreInfo(scope.row.orderId,false)"
                 style="text-decoration: underline;cursor: pointer;">
                Store rejected
            </span>
           </template>
        </el-table-column>
        <el-table-column prop="payAmount" label="Order Total" width="100">
          <template slot-scope="scope">
            <div>{{ scope.row.payAmount?Number(scope.row.payAmount).toLocaleString('en-US', { style: 'currency', currency: 'USD' }):'--' }}</div>
          </template>
        </el-table-column>
        <!-- 临时注释以下 -->
        <!--        <el-table-column prop="totalPriceOriginal" label="FOB Subtotal" width="120">
                </el-table-column>
                <el-table-column prop="orderDiscounted" label="Brand Disc" width="100">
                  <template slot-scope="scope">
                    {{scope.row['orderDiscounted']?scope.row['orderDiscounted']:0}}
                  </template>
                </el-table-column>
                <el-table-column prop="couponPrice" label="ShopVidi Disc" width="120">
                  <template slot-scope="scope">
                    {{scope.row['couponPrice']?scope.row['couponPrice']:0}}
                  </template>
                </el-table-column>
                <el-table-column prop="totalFreight" label="Shipping Fee" width="120">
                  <template slot-scope="scope">
                    {{scope.row['totalFreight']?scope.row['totalFreight']:0}}
                  </template>
                </el-table-column>
                <el-table-column prop="logisticUnderwriter" label="Shipping By" width="100">
                    <template slot-scope="scope">
                      <span v-if="scope.row['logisticUnderwriter']">ShopVidi</span>
                      <span v-else>Brand</span>
                    </template>
                </el-table-column>
                <el-table-column prop="logisticUnderwriter" label="Shipping Discount Provider" width="150">
                  <template slot-scope="scope">
                    <span v-if="scope.row['logisticUnderwriter']">ShopVidi</span>
                    <span v-else>Brand</span>
                  </template>
                </el-table-column>-->

        <!--
                <el-table-column prop="totalFreight" label="Shipping Price" width="130">
                </el-table-column>-->

        <el-table-column prop="brandName" label="Brand" width="">
        </el-table-column>
         <el-table-column prop="payTime" label="Pay Time" width="160">
          <template slot-scope="scope">
            <span v-if="scope.row.orderStatus !=0 && scope.row.orderStatus !=2 && scope.row.orderStatus !=11">
              {{ scope.row.payTime }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="shippingTime"
          label="Shipping Time"
          width="160"
        >

          <template slot-scope="scope">
            <span v-if="scope.row.orderStatus=='3'|| scope.row.orderStatus=='4' ||  scope.row.orderStatus=='5'">
              {{ scope.row.shippingTime }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="Invoice"
          width="130"
          v-if="supplierManagementModel!==2"
        >
          <template slot-scope="scope">
            <span v-if="operate || scope.row.userSource === 1 || supplierManagementModelFlag" @click="invoice(scope.row.orderId)" class="invoice-view">
              View
            </span>
            <span v-else>
              -
            </span>
          </template>
        </el-table-column>
        <el-table-column label="Memo" width="260">
          <template slot-scope="scope">
            <el-popover
              placement="top-start"
              width="200"
              trigger="hover"
              :content="scope.row.memo"
              v-if="scope.row.memo"
            >
              <div slot="reference" class="memo">
                <img src="@/assets/img/none-memo.png" alt="">
              </div>
            </el-popover>
            <!-- <div v-else class="memo">
              <img src="@/assets/img/none-memo.png" alt="">
            </div> -->

          </template>
        </el-table-column>
      </el-table>
      <!-- style="position: absolute;bottom:0" -->
      <Pagination
        :currentPage="selectData.pageNo"
        :total="selectData.total"
        :pageSize="selectData.pageSize"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></Pagination>
    </div>
    <el-dialog
      :visible.sync="acceptVisible"
      width="30%"
      @close="acceptVisible = false"
    >
      <span class="back_icon"><i class="el-icon-arrow-left"></i>Back</span>
      <p class="success_text" v-if="changeOrderNum == 40">
        Please review the Item availability before shipping orders
      </p>
      <p class="success_text" v-if="changeOrderNum == 2">
        Are you sure you want to cancel the order?
      </p>
      <p class="success_text" v-if="changeOrderNum == 5">
        Please confirm that your order has been shipped
      </p>
      <span slot="footer" class="dialog-footer flex_all">
        <el-button @click="acceptVisible = false">Cancel</el-button>
        <el-button type="primary" @click="confirmOrderStatus()"
        >Confirm</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="copyVisible"
      width="30%"
      @close="copyVisible = false;copyEdit = false"
    >
      <span class="back_icon"
      ><i class="el-icon-arrow-left"></i>Send Order Link</span
      >
      <div class="border_box">
        <p class="copy_title">Your Order Link</p>
        <p class="copy_subtitle">
          https://www.shopvidi.com/whosalesDetails/{{ rowOrderID }}
        </p>
        <p class="copy_title" v-if="brandShippingModel">ShopVidi Account</p>
        <p class="copy_subtitle" v-if="brandShippingModel">{{ nowretailerName }}</p>
      </div>
      <div class="flex_all">
        <el-button type="primary" class="back_button" @click="copyLink($event)"
        ><i class="el-icon-paperclip"></i>{{ copyEdit ? 'Copied' : 'Copy' }}
        </el-button
        >
      </div>
    </el-dialog>
    <!-- 缺货弹框 -->
     <out-stock-confirm-dialog ref="outStackDialog"></out-stock-confirm-dialog>
    <el-dialog :visible.sync="reviewOrderDialogVisible" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
        <div class="review-dialog-border">
          <div class="review-dialog-back" @click="back"><i class="el-icon-arrow-left"></i>Back</div>
          <div v-if="reviewOrderType ===1" class="review-dialog-pass" >
            <div class="review-dialog-tips">确认要将订单审核通过改为备货中吗？</div>
            <div class="review-dialog-action">
              <div v-loading="loading" class="review-dialog-cancel" @click="cancle">Cancel</div>
              <div v-loading="loading" class="review-dialog-confirm" @click="confirm">Confirm</div>
            </div>
          </div>
          <div v-if="reviewOrderType ===0" class="review-dialog-reject">
            <div class="review-dialog-tips">确认要拒绝履约该订单吗？</div>
            <div class="review-dialog-action">
              <div v-loading="loading" class="review-dialog-cancel" @click="cancle">Cancel</div>
              <div v-loading="loading" class="review-dialog-confirm" @click="confirm">Confirm</div>
            </div>
          </div>
        </div>
      </el-dialog>
  </div>
</template>

<script>
import {postAction, getAction, putAction} from '@/api/manage.js'
import Pagination from '../components/pagination.vue'
import {handleClipboard} from '@/utils/copy'
import CustomBreadcrumb from '../components/custom-breadcrumb'
import outStockConfirmDialog from './out-stock-confirm-dialog'
import {orderStatusArr, orderStatusDis} from '../../utils/status'
import {parseTime} from '@/utils/formatDate'

export default {
  components: {Pagination, CustomBreadcrumb, outStockConfirmDialog},
  data() {
    return {
      superUserId: '1526126197658583041', // 默认正式用户
      loading: false,
      orderId: '',
      reviewOrderType: 0,
      reviewOrderDialogVisible: false,
      pageLoading: false,
      userInfo: {},
      rowOrderID: '',
      copyEdit: false,
      orderLink: '',
      nowretailerName: '',
      changeOrderId: '',
      changeOrderNum: '',
      acceptVisible: false,
      copyVisible: false,
      orderChangeTime: 7,
      total: 0,
      startTime: '',
      endTime: '',
      selectDate: '',
      ordersCount: '',
      ordersData: [],
      value: '',
      supplierManagementModelFlag: true, // 判断是入住还是自营（不再判断）
      supplierManagementModel: 1, // 判断是入住还是自营 true：入驻
      operate: false, // 判断是不是运营账号
      isVidirect: false, // 判断是不是 vidirect 供应商
      brandShippingModel: false, // 动态是否显示用户信息,
      orderType: [
        {label: 'Wholesale Order', value: 1},
        {label: 'Retailer Order', value: 2},
        {label: 'ViLocal Order', value: 7}
      ],
      orderStatua: [
        {label: 'Unpaid', value: 0},
        {label: 'Paid', value: 1},
        {label: 'Cancelled', value: 2},
        {label: 'Shipped', value: 3},
        {label: 'Partial Shipped', value: 4},
        {label: 'Received', value: 5},
        {label: 'Refund under review', value: 6},
        {label: 'Refunded', value: 7},
        {label: 'Declined on Refund', value: 8},
        {label: 'On Hold', value: 31},
        {label: 'Progressing', value: 10},
        {label: 'Partial refund', value: 9},
        {label: 'Failed', value: 11},
        {label: 'Returning', value: 13},
        {label: 'Return completed', value: 23},
        {label: 'Complete partially', value: 24},
        {label: 'Closed', value: 99},
        {label: 'Packaging', value: 40},
        {label: 'Partial Delivered', value: 52},
        {label: 'Delivered', value: 53},
        {label: 'Partial Received', value: 54}
      ],
      selectData: {
        keyWords: '',
        dateValue: '',
        selectOrderStatus: '',
        selectOrderType: '',
        pageSize: 20,
        pageNo: 1
      }
    }
  },
  created() {
    if (process.env.NODE_ENV === 'test' || process.env.NODE_ENV === 'development') {
      this.superUserId = '1534004062118182913'
    }
    const start = parseTime(new Date(new Date().getTime() - 16 * 24 * 60 * 60 * 1000),'{y}-{m}-{d}');
    this.selectData.dateValue = start;
  },
  mounted() {
    this.loadBrandInfo()
    this.getLatelyDays(7)
    this.loadOrdersCount()
    this.loadOrdersData()
  },
  filters: {
    statusDis: (value) => {
      return orderStatusDis(value)
    }
  },
  methods: {
    gotoStoreInfo(orderId, flag) {
      const params = {}
      params.orderId = orderId
      // 如果是运营加
      if (!flag) {
        params.role = 'operation'
      } else {
        params.role = 'brand'
      }
      this.$router.push({path: 'store-review', query: params})
    },
    cancle() {
      this.reviewOrderDialogVisible = false
      this.orderId = ''
    },
    confirm() {
      if (this.loading) {
        return
      }
      this.updateOrder(this.orderId, this.reviewOrderType)
    },
    back() {
      this.cancle()
    },
    showReviewOrderDialog(orderId) {
      this.reviewOrderDialogVisible = true
      this.orderId = orderId
    },
    updateOrder(orderId, status) {
      this.loading = true
      putAction('/sp/suppliers/orders/' + orderId + '/' + status + '/audit').then(response => {
        if (response.success) {
          this.loading = false
          this.cancle()
          this.$message.success(response.message)
          this.loadOrdersData()
        } else {
          this.loading = false
          this.$message.warning(response.message)
        }
      })
    },
    passOrder(orderId) {
      this.showReviewOrderDialog(orderId)
      this.reviewOrderType = 1
    },
    rejectOrder(orderId) {
      this.showReviewOrderDialog(orderId)
      this.reviewOrderType = 0
    },
    openEditOrder(order) {
      this.$router.push({path: 'editOrder', query: {orderId: order}})
    },
    loadBrandInfo() {
      // 此处不调用后端了，采用前端的方式来处理，判断localStorage
      let userInfo = JSON.parse(localStorage.getItem('pro__userInfo')).value
      this.userInfo = userInfo
      // 如果是运营账号
      if (userInfo.model === '4') {
        this.operate = true
      }
      // 2023/07/10 入住和自营 不再做功能上的区别
      // if (userInfo.supplierManagementModel === 1) {
      //   this.supplierManagementModelFlag = true
      // } else {
      //   this.supplierManagementModelFlag = false
      // }
      if (userInfo.isVidirect) {
        this.isVidirect = true
      } else {
        this.isVidirect = false
      }
      this.supplierManagementModel = userInfo.supplierManagementModel

    },
    invoice(orderId) {
      this.$router.push({
        path: `invoice?orderId=${orderId}`
      })
      // this.$router.push({ path: 'Order' })
    },
    changeOrderButton(orderId, newOrderStatus, button) {
      this.changeOrderId = orderId
      this.changeOrderNum = newOrderStatus
      this.acceptVisible = true
      if (button == 'Cancel') {
        this.CancelEdit = true
        this.ShippedEdit = false
        this.AcceptEdit = false
      } else if (button == 'Accept') {
        this.CancelEdit = false
        this.ShippedEdit = false
        this.AcceptEdit = true
      } else if (button == 'Shipped') {
        this.CancelEdit = false
        this.ShippedEdit = true
        this.AcceptEdit = false
      }
    },
    toOrderDetail(row) {
      let id = row['orderId'], brandShippingModel = row['brandShippingModel'], userSource = row['userSource']
      this.$router.push({
        path: 'OrderDetail',
        query: {'orderId': id, 'brandShippingModel': brandShippingModel, 'userSource': userSource}
      })
    },
    gotoShipped(row) {
      let id = row['orderId'], brandShippingModel = row['brandShippingModel'], userSource = row['userSource']
      this.$router.push({
        path: 'shipping',
        query: {'orderId': id, 'brandShippingModel': brandShippingModel, 'userSource': userSource}
      })
    },
    confirmOrderStatus() {
      this.acceptVisible = false
      this.changeOrderStatus(this.changeOrderId, this.changeOrderNum)
    },
    toCopyInfo(link, orderid, brandShippingModel) {
      this.copyVisible = true
      this.rowOrderID = orderid
      this.orderLink = 'Your Order Link : https://www.shopvidi.com/whosalesDetails/' + orderid
      // notes 判断 是否需要显示用户
      if (brandShippingModel !== null && brandShippingModel === 2) {
        this.brandShippingModel = true
        this.orderLink = this.orderLink + '\r\n' + 'shopvidi Account : ' + link
      } else {
        this.brandShippingModel = false
      }
      this.nowretailerName = link
    },
    copyLink(e) {
      this.copyEdit = !this.copyEdit
      handleClipboard(this.orderLink, e)
    },
    toCreateOrder() {
      this.$router.push({path: 'creatOrder'})
    },
    search() {
    },
    handleSizeChange(val) {
      this.selectData.pageSize = val
      this.loadOrdersData()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`, this.selectData)
      this.selectData.pageNo = val
      this.loadOrdersData()
    },
    loadOrdersCount() {
      getAction('/sp/suppliers/retailers/orders/count?' + this.selectDate).then(
        (res) => {
          if (res.success) {
            this.ordersCount = res.result
          } else {
            this.$message.warning(res.message)
          }
        }
      )
    },
    loadOrdersData() {
      this.pageLoading = true
      if (this.selectData.dateValue == null) {
        this.selectData.dateValue = ''
      }
      let orderType = this.$route.query.orderType ? this.$route.query.orderType : this.selectData.selectOrderType
      getAction(
        '/sp/suppliers/retailers/orders?currentPage=' +
        this.selectData.pageNo +
        '&pageSize=' +
        this.selectData.pageSize +
        '&startTime=' +
        this.selectData.dateValue +
        '&orderStatus=' +
        this.selectData.selectOrderStatus +
        '&orderType=' +
        orderType +
        '&keyWords=' +
        this.selectData.keyWords
      ).then((res) => {
        if (res.success) {
          this.pageLoading = false
          this.ordersData = res.result.records
          console.log(this.ordersData, this.ordersData.length, 'jjss')
          this.selectData.pageSize = res.result.size
          this.selectData.pageNo = res.result.current
          this.selectData.total = res.result.total
        } else {
          this.pageLoading = false
          this.$message.warning(res.message)
        }
      })
    },
    // 更改订单状态
    changeOrderStatus(id, status) {
      putAction(
        '/sp/suppliers/retailers/orders/' + id + '/' + status
      ).then((res) => {
        if (res.success) {
          this.loadOrdersData()
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    getLatelyDays(day) {
      let date = ''
      let toDay = new Date(new Date().toLocaleDateString()).getTime()
      let startDate = new Date(toDay - Number(day) * 3600 * 24 * 1000)
      let endDate = new Date(toDay + 24 * 3600 * 1000 - 1)
      this.startTime =
        startDate.getFullYear() +
        '-' +
        this.formatNumber(startDate.getMonth() + 1) +
        '-' +
        this.formatNumber(startDate.getDate())
      this.endTime =
        endDate.getFullYear() +
        '-' +
        this.formatNumber(endDate.getMonth() + 1) +
        '-' +
        this.formatNumber(endDate.getDate())
      date = 'startTime=' + this.startTime + '&endTime=' + this.endTime + ' 23:59:59'
      this.selectDate = date
      return date
    },
    formatNumber(num) {
      num = num.toString()
      return num[1] ? num : '0' + num
    },
    changeOrderTime(command) {
      if (command == 'All') {
        this.orderChangeTime = command
        this.selectDate =
          'startTime=1990-01-01&endTime=' +
          new Date().getFullYear() +
          '-' +
          this.formatNumber(new Date().getMonth() + 1) +
          '-' +
          this.formatNumber(new Date().getDate())
      } else {
        this.orderChangeTime = Number(command)
        this.selectDate = this.getLatelyDays(command)
      }
      this.loadOrdersCount()
      // console.log('changeOrderTime', command)
    },
    changSelectHandel() {
      this.selectData.pageSize = 20
      this.selectData.pageNo = 1
      this.loadOrdersData()
    },
    getStatus(t) {
      if (t === 0) {
        return 'Unpaid'
      } else if (t === 1) {
        return 'Paid'
      } else if (t === 2) {
        return 'Cancelled'
      } else if (t === 3) {
        return 'Shipped'
      } else if (t === 4) {
        return 'Partial Shipped'
      } else if (t === 5) {
        return 'Received'
      } else if (t === 6) {
        return 'Refund under review'
      } else if (t === 7) {
        return 'Refunded'
      } else if (t === 8) {
        return 'Declined on Refund'
      } else if (t === 31) {
        return 'On Hold'
      } else if (t === 10) {
        return 'Progressing'
      } else if (t === 9) {
        return 'Partial refund'
      } else if (t === 11) {
        return 'Failed'
      } else if (t === 13) {
        return 'Returning'
      } else if (t === 16) {
        return 'Refunding'
      } else if (t === 23) {
        return 'Return completed'
      } else if (t === 24) {
        return 'Complete partially'
      } else if (t === 99) {
        return 'Tranding closed'
      } else if (t === 40) {
        return 'Packaging'
      } else if (t === 42) {
        return 'Canceled'
      } else if (t === 52) {
        return 'Partial Delivered'
      } else if (t === 53) {
        return 'Delivered'
      } else if (t === 54) {
        return 'Partial Received'
      }
    }

  }
}
</script>

<style lang="less" scoped>

.review-dialog-border{
  width: 96%;
  margin:0 auto;
}
.review-dialog-back{
  width: 10%;
  font-size: 14px;
  font-family: Satoshi-Medium !important;
  cursor: pointer;
  color: #262B2F;
  padding: 20px 0px 10px 0px;
}
.review-dialog-tips{
  width: 90%;
  margin: 0 auto;
  font-size: 14px;
  font-family: Satoshi-Medium !important;
  line-height: 20px;
  color: #000000;
  opacity: 1;
}
.review-dialog-action{
  width: 90%;
  margin:0 auto;
  margin-top: 20px;
  padding-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .review-dialog-cancel,.review-dialog-confirm{
    width: 48%;
    height: 41px;
    border: 1px solid #707070;
    opacity: 1;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Satoshi-Medium !important;
    cursor: pointer;
  }
  .review-dialog-cancel{
    background:#FFFFFF
  }
  .review-dialog-confirm{
    background:#262B2F;
    color:#FFFFFF
  }
}
.order_title {
  margin: 0px 30px 20px 0px !important;
  height: 35px;
  line-height: 35px;
  margin-right: 0px !important;
}

/deep/ .cell {
  font-size: 14px;
  font-family: Avenir;
  font-weight: 500;
  color: #000000;
}

.el-button--primary,
.el-button--primary:focus,
.el-button--primary:hover {
  background-color: #262b2f !important;
  border-color: #262b2f !important;
}

/deep/ .el-tabs__nav-scroll {
  border-bottom: 1px solid #e1e1e1;
}

/deep/ .el-tabs__item.is-active {
  color: #262b2f !important;
}

/deep/ .el-tabs__item:hover {
  color: #262b2f !important;
}

/deep/ .el-tabs__item {
  width: 100px;
  text-align: center;
  color: #5d5d5d;
}

/deep/ .el-tabs__active-bar {
  background-color: #262b2f !important;
}

.search-box {
  width: 96%;
  display: flex;
  margin: 20px 0 0 0;
  height: 40px;

  .date_text {
    width: 100px;
    height: 40px;
    border: 1px solid #dcdfe6;
    line-height: 40px;
    text-align: center;
    color: #8f8f8f;
    border-right: none;
    margin-left: 16px;
  }
}

.search-btn {
  background-color: #262b2f;
  border-color: #262b2f;
  width: 100px;
  border-radius: 0;
}

.action_button {
  background-color: #262b2f;
  border-color: #262b2f;
  width: 74px;
  height: 30px;
  line-height: 30px;
  padding: 0 !important;
}
.action_button2{
  margin-top: 10px;
  width: unset;
  padding: 0 10px !important;
}

.orange_background {
  width: 110px !important;
  background: #fb541c !important;
  border-color: #fb541c !important;
}

.search_input {
  width: 45%;
  margin-left: 16px;
}

.order_box {
}

.creat_button {
  width: 146px;
  height: 40px;
  background: #262b2f;
  border: 1px solid #262b2f;
  opacity: 1;
  border-radius: 3px;
  outline: none;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}

.order_nav {
  width: 100%;
  height: 94px;
  background: #262b2f;
  border: 1px solid #707070;
  border-radius: 10px;
  color: #fff;
  align-items: center;

  .nav_msg:last-child {
    border-right: none;
  }

  .nav_msg {
    flex-direction: column;
    padding: 20px 0 0 40px;
    width: 15%;
    height: 80%;
    border-right: solid 1px #707070;

    .nac_msg_num {
      margin-top: 4px;
    }

    .el-dropdown {
      margin-top: 10px;
      width: 80px;
    }

    .el-dropdown-link {
      color: #fff;
    }
  }
}

.page_table {
  width: 100%;

  /deep/ .pageSize {

  }

}

.little_logo {
  width: 13px;
  height: 13px;
  margin-right: 2px;
}

.success_text {
  font-size: 14px;
  font-family: Graphik;
  font-weight: 400;
  line-height: 18px;
  color: #262b2f;
  text-align: center;
  margin-top: 10px;
}

.back_icon {
  font-size: 14px;
  font-family: Avenir;
  font-weight: 500;
  line-height: 40px;
  color: #262b2f;
  margin: 0 0 0 10px;
}

.dialog-footer {
  margin-top: 10px;
}

.retailername_style {
  align-items: center;
}

.border_box {
  width: 80%;
  height: auto;
  padding: 20px;
  border: 1px solid #dcdfe6;
  margin: 10px 0 15px 10%;

  .copy_title {
    font-size: 13px;
    font-family: Graphik;
    font-weight: 500;
    line-height: 28px;
    color: #262b2f;
  }

  .copy_subtitle {
    font-size: 14px;
    font-family: Graphik;
    font-weight: 400;
    line-height: 18px;
    color: #5d5d5d;
  }
}

.back_button {
  margin-bottom: 15px;
  width: 140px;
}

.memo {
  width: 16px;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
  }
}

.invoice-view {
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #0A89FE;
  text-decoration: underline;
}

/* 给固定列设置下边距 */
/deep/ .el-table .el-table__fixed {
  height: auto !important;
  bottom: 16px !important; /* 具体值是多少根据你横向滚动条的高度进行设置 */
}

/* 去掉固定列下方的横线 */
/deep/ .el-table__fixed::before, .el-table__fixed-right::before {
  display: none;
}

/deep/ .el-button+.el-button{margin-left: unset!important;}

/deep/ .el-dialog{
  width: 500px;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/index.vue